import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { RefreshCw, CheckCircle } from "lucide-react";

/**
 * Utility Header - Trust signals and data freshness indicators
 * Makes users feel this is a maintained, reliable tool
 */
export default function UtilityHeader({ eventCount = 144 }) {
  const [lastUpdated, setLastUpdated] = useState("");

  useEffect(() => {
    // Show "today" or actual date
    const now = new Date();
    const options = { day: "numeric", month: "short", year: "numeric" };
    setLastUpdated(now.toLocaleDateString("ms-MY", options));
  }, []);

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-muted-foreground">
      {/* Event count */}
      <div className="flex items-center gap-1.5">
        <span className="font-semibold text-foreground">{eventCount}+</span>
        <span>events</span>
      </div>

      {/* Divider */}
      <span className="hidden sm:inline text-white/20">•</span>

      {/* Last updated */}
      <div className="flex items-center gap-1.5">
        <RefreshCw className="h-3 w-3" />
        <span>Updated: {lastUpdated}</span>
      </div>

      {/* Divider */}
      <span className="hidden sm:inline text-white/20">•</span>

      {/* Verified badge */}
      <div className="flex items-center gap-1.5">
        <CheckCircle className="h-3 w-3 text-emerald-400" />
        <span>Dates verified</span>
      </div>
    </div>
  );
}

/**
 * Sticky utility bar at top
 */
export function StickyUtilityBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [dayOfWeek, setDayOfWeek] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    
    // Get day name
    const days = ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"];
    setDayOfWeek(days[new Date().getDay()]);
    
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="fixed top-20 left-0 right-0 z-40 pointer-events-none"
    >
      <div className="max-w-md mx-auto px-4">
        <div className="glass-card rounded-full px-4 py-2 text-center shadow-lg pointer-events-auto">
          <p className="text-xs text-muted-foreground">
            <span className="text-pink-400 font-medium">{dayOfWeek}</span>
            {" • "}
            <span>Check events untuk minggu ni</span>
          </p>
        </div>
      </div>
    </motion.div>
  );
}
